import _ from 'lodash';
import React from 'react';

import { Checkbox, Dropdown } from 'semantic-ui-react';

const CheckableDropdownItem = (props) => {
    const {
        disabled,
        group,
        header,
        onClick,
        selected,
        text,
        value,
        ...rest
    } = props;

    const classes = !_.isNil(group)
        ? 'grouped'
        : '';

    return (
        <Dropdown.Item
            id={value}
            group={group}
            className={classes}
            {...!disabled && { onClick }}
            {...!_.isNil(onClick) && { selected }}
            {...header && { as: Dropdown.Header }}
        >
            <Checkbox
                label={text}
                disabled={disabled}
                {...!_.isNil(onClick) && { checked: selected }}
                {...rest}
            />
        </Dropdown.Item>
    );
};

export default CheckableDropdownItem;
